// Libs
import React, { useEffect, useState } from "react";
import { useObserver, useRouter } from "@shoothill/core";
import { Link as RouterLink } from "react-router-dom";
import { Box, Typography, Paper, Link } from "@material-ui/core";
import styled from "styled-components";

// App
import { AppUrls } from "AppUrls";
import { ApplicantStatusEnum } from "Globals/Models/ApplicantStatusEnum";
import AdminApplicantViewModel from "Globals/ViewModels/Applicant/AdminApplicantViewModel";
import ApplicationFormViewModel from "Globals/ViewModels/ApplicationFormViewModel";
import { PaymentModal } from "Views/Application/Modal/PaymentModal";
import { StyledLinkButton } from "Views/Admin/Applicants/Applicant/AdminApplicantView";
import PaymentViewModel from "Globals/ViewModels/Payment/PaymentViewModel";
import DashboardApplicationViewModel from "Globals/ViewModels/Dashboard/DashboardApplicationViewModel";
import { ApplicationFormStatusEnum } from "Globals/Models";
interface IProps {
    paymentViewModel: PaymentViewModel;
    viewModel: DashboardApplicationViewModel;
    index: number;
}

export const ApplicationCardContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    p {
        font-size: 12px;
        font-weight: 600;
    }
`;

export const Application: React.FC<IProps> = (props: IProps) => {
    const [viewModel] = useState(props.paymentViewModel);
    const [applicationFormViewModel] = useState(() => new ApplicationFormViewModel(props.viewModel.model.id ? props.viewModel.model.id : ""));
    const [adminApplicantViewModel] = useState(() => new AdminApplicantViewModel(props.viewModel.model.createdByUserId ? props.viewModel.model.createdByUserId : ""));
    const [modalStatus, setModalStatus] = useState(false);
    const { history } = useRouter();

    useEffect(() => {
        const handler = async (event: any) => {
            const data = event.data;
            if (data.resultCode === "0") {
                await adminApplicantViewModel.updateApplicantStatus(ApplicantStatusEnum.ReservationFeePaid);
                await applicationFormViewModel.updateApplicationFormStatus(ApplicationFormStatusEnum.ReservationPaid);
                if (applicationFormViewModel.model.id) {
                    await adminApplicantViewModel.insertAllPay(applicationFormViewModel.model.id, 500);
                }
                history.push("/");
            }
        };
        window.addEventListener("message", handler);
        // clean up
        return () => window.removeEventListener("message", handler);
    }, []);

    const modals = () => (
        <>
            {modalStatus && (
                <PaymentModal
                    isActive={modalStatus}
                    paymentViewModel={viewModel}
                    adminApplicantViewModel={adminApplicantViewModel}
                    confirmClose={() => {
                        viewModel.handleGetPaymentToken();
                        setModalStatus(false);
                    }}
                    onCancel={() => setModalStatus(false)}
                />
            )}
        </>
    );

    const application = () => (
        <>
            <ApplicationCardContainer>
                <Box>
                    <Paper>
                        <Link component={RouterLink} to={AppUrls.Client.Application.replace(":applicationId?", props.viewModel.model.id ? props.viewModel.model.id : "")}>
                            <Box
                                paddingX="15px"
                                paddingY="15px"
                                flexDirection={"column"}
                                display={"flex"}
                                style={
                                    props.viewModel.rejectReason
                                        ? { backgroundColor: "#F3D1D4", border: "solid 1px #DC3545" }
                                        : props.viewModel.status?.type == ApplicationFormStatusEnum.ReservationPaid
                                        ? { backgroundColor: "#D6EDD5", border: "solid 1px ##3AAA35" }
                                        : {}
                                }
                            >
                                {props.viewModel.model.submittedDate ? (
                                    <>
                                        <Typography style={{ marginBottom: "8px" }} variant={"body1"}>
                                            Application submitted: &nbsp;{props.viewModel.submittedDate}
                                        </Typography>
                                        <Typography variant={"body1"}>
                                            Current status: &nbsp;{" "}
                                            <Typography
                                                component={"span"}
                                                style={{
                                                    fontSize: "12px",
                                                    display: "inline",
                                                    color: `${props.viewModel.status?.color}`,
                                                }}
                                            >
                                                <span>
                                                    {props.viewModel.statusName}
                                                    {`${props.viewModel.rejectReason ? ":" : ""}`}
                                                    {props.viewModel.rejectReason?.name}
                                                </span>
                                            </Typography>
                                        </Typography>
                                    </>
                                ) : (
                                    <Typography variant={"body1"}>Application last saved: {props.viewModel.lastSaved}</Typography>
                                )}
                            </Box>
                        </Link>
                        {props.viewModel.model.applicantUserStatus.toLocaleLowerCase() === "pending reservation fee" &&
                            applicationFormViewModel.applicationStatusEnum === ApplicationFormStatusEnum.PaymentRequired && (
                                <>
                                    <Box paddingLeft="15px" paddingBottom="15px" paddingRight="15px">
                                        <StyledLinkButton
                                            fullWidth
                                            onClick={() => {
                                                viewModel.handleGetPaymentToken();
                                                setModalStatus(true);
                                            }}
                                            style={{ backgroundColor: "#84BB25" }}
                                        >
                                            Pay now
                                        </StyledLinkButton>
                                    </Box>
                                </>
                            )}
                    </Paper>
                </Box>
            </ApplicationCardContainer>
            {modals()}
        </>
    );

    return useObserver(() => application());
};
